<template>
  <div
    id="app"
  >
    <app-header
      class="long-title-menu-down"
      app-title="Vendor Payments"
      :is-fluid="true"
    >
      <tabs-nav
        v-if="!routeHidingNavLink.includes($route.name)"
        slot="tabs-nav"
      >
        <router-link
          v-for="(menu, index) in menuOptions"
          :key="index"
          :to="{ name: menu.href }"
          :class="{ 'is-active': currentMenus.includes(menu.text) }"
        >
          {{ menu.text }}
        </router-link>
      </tabs-nav>

      <dropdown-nav
        v-if="Object.keys(this.loggedIn).length"
        slot="dropdown-nav"
        :nav="myDropdownNavLink"
      />

      <mobile-nav
        slot="mobile-nav"
        :links="allLinks"
      >
      </mobile-nav>

    </app-header>

    <main class="main section">
      <slot />
    </main>

    <app-footer
      :links="footerLinks"
      :is-sticky="true"
    />
  </div>
</template>

<script>

import {
  AppHeader,
  TabsNav,
  DropdownNav,
  MobileNav,
  AppFooter,
} from '@phila/phila-ui';

import { EventBus } from '@/plugins/bus.js';

export default {
  name: "Default",
  components: {
    AppHeader,
    TabsNav,
    DropdownNav,
    MobileNav,
    AppFooter,
  },
  data() {
    return {
      menuOptions: [],
      routeHidingNavLink: [
        'login',
        'maintenance',
        'faq',
        'ach-vendor-letter',
      ],
      myDropdownNavLink: {
        button: this.$store.state.login.loggedIn.firstName + ' ' + this.$store.state.login.loggedIn.lastName,
        icon: true,
        links: [
          {
            href: "profile",
            text: "Profile",
          },
          {
            type: 'native',
            text: "Logout",
            click: () => {
              this.$store.dispatch('login/logOut');
            },
          },
        ],
      },
      footerLinks: [
        {
          type: 'native',
          text: 'Terms of Use',
          click: () => {
            EventBus.$emit('show-terms-and-conditions');
          },
        },
        {
          text: 'FAQ',
          href: 'faq',
          attrs: {
            target: '_blank',
          },
        },
      ],
    };
  },
  computed: {
    currentMenus() {
      return this.$route.matched.map((r) => {
        return r.meta.menu || r.meta.from || '';
      });
    },
    allLinks() {
      return this.menuOptions.concat(this.footerLinks).concat(this.myDropdownNavLink.links).concat(this.footerLinks);
    },
    achFormEnabled() {
      let value;
      if (process.env.VUE_APP_ACH_FORM_ENABLED === 'true') {
        value = true;
      } else {
        value = false;
      }
      return value;
    },
    achRequestEnabled() {
      let value;
      if (process.env.VUE_APP_ACH_REQUEST_ENABLED === 'true') {
        value = true;
      } else {
        value = false;
      }
      return value;
    },
  },
  watch: {
    "$route"() {
      this.calculateMenu();
    },
  },
  beforeMount() {
    this.calculateMenu();
    // const html = document.getElementsByTagName('html')[0].remove('is-login');
  },
  methods: {
    calculateMenu() {
      const currentRoute = this.$route.name || '';

      let allRoutes = this.getRoutes(this.$router.options.routes);
      let menuInRoutes = allRoutes.filter(route => (route.meta) ? !!route.meta.menu : false);

      // console.log('calculateMenu is running, this.curUserType:', this.curUserType);

      menuInRoutes = menuInRoutes.filter((route) => {
        // TODO: Removing hardcoding for this validation and made it correctly
        // console.log('in filter function, route:', route);
        if (route.meta.hideFor) {
          if (route.meta.hideFor.indexOf(this.curUserType) !== -1) {
            return false;
          }
        }

        if (typeof route.meta.user === 'object') {
          return route.meta.user.indexOf(this.curUserType) !== -1;
        }

        if (route.meta.requiresAuth === true) {
          // console.log("resolve as: ", (this.isLoggedIn && currentRoute !== 'login'));
          return this.isLoggedIn && currentRoute !== 'login';
        }

        return true;
      });

      console.log('layouts/Default.vue calculateMenu is running, allRoutes:', allRoutes, 'menuInRoutes:', menuInRoutes);

      // sets order of menu options
      this.menuOptions = [];

      if (menuInRoutes.filter(x => x.name === 'vendor-paid')[0]) {
        let vendorPaid = {
          href: 'vendor-paid',
          text: menuInRoutes.filter(x => x.name === 'vendor-paid')[0].meta.menu,
        };
        this.menuOptions.push(vendorPaid);
      }

      if (menuInRoutes.filter(x => x.name === 'invoice-form')[0]) {
        let invoiceForm = {
          href: 'invoice-form',
          text: menuInRoutes.filter(x => x.name === 'invoice-form')[0].meta.menu,
        };
        this.menuOptions.push(invoiceForm);
      }

      if (this.achFormEnabled) {
        if (menuInRoutes.filter(x => x.name === 'ach-form')[0]) {
          let achForm = {
            href: 'ach-form',
            text: menuInRoutes.filter(x => x.name === 'ach-form')[0].meta.menu,
          };
          this.menuOptions.push(achForm);
        }
      }

      if (menuInRoutes.filter(x => x.name === 'vendors')[0]) {
        let vendors = {
          href: 'vendors',
          text: menuInRoutes.filter(x => x.name === 'vendors')[0].meta.menu,
        };
        this.menuOptions.push(vendors);
      }

      if (menuInRoutes.filter(x => x.name === 'invoices')[0]) {
        let invoices = {
          href: 'invoices',
          text: menuInRoutes.filter(x => x.name === 'invoices')[0].meta.menu,
        };
        this.menuOptions.push(invoices);
      }

      if (menuInRoutes.filter(x => x.name === 'department-finance')[0]) {
        let departmentFinance = {
          href: 'department-finance',
          text: menuInRoutes.filter(x => x.name === 'department-finance')[0].meta.menu,
        };
        this.menuOptions.push(departmentFinance);
      }

      if (menuInRoutes.filter(x => x.name === 'vendor-users')[0]) {
        let vendorUsers = {
          href: 'vendor-users',
          text: menuInRoutes.filter(x => x.name === 'vendor-users')[0].meta.menu,
        };
        this.menuOptions.push(vendorUsers);
      }

      if (this.achRequestEnabled) {
        if (menuInRoutes.filter(x => x.name === 'ach-request')[0]) {
          let achForm = {
            href: 'ach-request',
            text: menuInRoutes.filter(x => x.name === 'ach-request')[0].meta.menu,
          };
          this.menuOptions.push(achForm);
        }
      }
    },
    getRoutes(array) {
      let objects = [];
      array.forEach((arr) => {
        if (arr.children) {
          objects = objects.concat(this.getRoutes(arr.children));
        } else {
          objects.push(arr);
        }
      });
      return objects;
    },
  },
};
</script>

<style lang="scss" scoped>

  .main {
    margin-top: 1rem !important;
  }

</style>
